import { StringLiteral } from "typescript";
import { InputType } from "./common";
import { ContactModel, IPhoneNumber } from "./contact";

export type ServiceStatus =
  | "New"
  | "Created"
  | "Approved"
  | "Active"
  | "Paused"
  | "Added";

export interface IFileInfo {
  key: string;
  version: string;
  fileName?: string;
  signedUrl?: string;
}

export interface BusinessInfoModel {
  businessId: string;
  businessCode: string;
  name: string;
  website: string;
  dunsNumber: string;
  status: ServiceStatus;
  countryCode: string;
  logo?: IFileInfo;
}

// export interface RegionalAttribute {
//   name: string;
//   title: string;
//   value?: string;
//   type: InputType;
// }

// export interface BusinessDetailsModel {
//   fields: RegionalAttribute[];
// }

export interface INewNumberModel {
  businessNumber: string;
  pilotLimit?: number;
  ownershipDocuments: IFileInfo[];
  status: ServiceStatus;
}

export interface IAttribute {
  name: string;
  sectionId: number;
  title: string;
  isMandatory: boolean;
  dataType: string; // Data type, e.g., "S" for string
  display: boolean;
  value: {
    name: string;
    value: string;
  };
}

export interface IAttributeSection {
  sectionName: string;
  sectionId: number;
  attributes: IAttribute[];
}

export interface IContactInfo {
  isActive: boolean;
  createdDate: number; // Unix timestamp
  lastName: string;
  updatedDate: number; // Unix timestamp
  firstName: string;
  phoneNumber: IPhoneNumber;
  id: string;
  emailId: string;
}

export interface IBusinessNumber {
  businessNumber: string;
  ownershipDocuments: IFileInfo[];
  status: ServiceStatus;
  scProvidedNumber: boolean;
  pilotLimit?: number;
}

export interface BusinessModel {
  businessId: string;
  name: string;
  dunsNumber: string;
  status: ServiceStatus;
  countryCode: string;
  logo: IFileInfo;
  industry: string;
  website: string;
  primaryContact: IContactInfo;
  attributeSections: IAttributeSection[];
  businessNumbers: IBusinessNumber[];
}

export interface BusinessListModel {
  businessId: string;
  businessCode: string;
  name: string;
  status: ServiceStatus;
  trialEnabled?: boolean;
  logo: IFileInfo;
}

export interface IFileWithSignedUrl {
  fileName: string;
  signedUrl: string;
}

export interface IFileWithVersion {
  key: string;
  version: string;
  fileName?: string;
}

export enum CPaaSProvider {
  Vonage = "Vonage"
}

export interface VonageApplicationConfig {
  applicationId: string;
  privateKeyFile: IFileWithVersion;
  apiSignatureSecret?: string;
}
export type TVonageApplicationConfigRequest = Omit<VonageApplicationConfig, 'privateKeyFile'> & {
  privateKeyFile: IFileWithSignedUrl;
};

export interface IBusinessNumberApprovalRequest {
  businessNumber: string
  pilotSetupLimit?: number;
}

export interface IBusinessNumberApprovalRequest {
  businessNumber: string;
  pilotSetupLimit?: number;
}

export interface IApproveBusinessRequest {
  businessId: string;
  businessNumbers?: IBusinessNumberApprovalRequest[];
  approvalDetails?: IBusinessApprovalRequest;
}

export interface IBusinessApprovalRequest {
  comments: string;
  numberProviderConfig?: TVonageApplicationConfigRequest;
  numberProvider?: CPaaSProvider;
  supportEmailAddress?: string;
}
